import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { VisibilityIcon, VisibilityOffIcon } from "../../../utils/icons";
import { Colors } from "../../../utils/style/colors";

// Hides a configuration group or a single setting from the account's own users.
export default function VisibilityToggle({ hidden, onToggle, group, sx = {} }) {
  const { t } = useTranslation();

  const title = group
    ? hidden
      ? t("customerCannotSeeThisSection", {
          defaultValue: "Hidden for the customer — click to show",
        })
      : t("customerCanSeeThisSection", {
          defaultValue: "The customer can see this configuration section",
        })
    : hidden
    ? t("customerCannotSeeThisSetting", {
        defaultValue: "Hidden for the customer — click to show",
      })
    : t("customerCanSeeThisSetting", {
        defaultValue: "The customer can see this setting",
      });

  const activate = (e) => {
    e.stopPropagation();
    onToggle();
  };

  return (
    <Tooltip title={title} placement="top" arrow>
      {/* A span, not a button: accordion headers are themselves a <button>. */}
      <IconButton
        component="span"
        role="button"
        tabIndex={0}
        aria-label={title}
        size="small"
        sx={{ flexShrink: 0, alignSelf: "center", ...sx }}
        onClick={activate}
        // ButtonBase already turns Enter/Space into a click; just keep the key
        // event away from the accordion header.
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") e.stopPropagation();
        }}
      >
        {hidden ? (
          <VisibilityOffIcon size={0.8} color={Colors.danger} />
        ) : (
          <VisibilityIcon size={0.8} color={Colors.gray50} />
        )}
      </IconButton>
    </Tooltip>
  );
}
